"use client";
import React, { useEffect, useState } from "react";
import "./index.css";
import { Container, Nav, Navbar } from "react-bootstrap";
import NavigationDropdown from "./NavigationDropdown";
import Link from "next/link";
import CustomButton from "@/components/common-components/CustomButton";
import { usePathname } from "next/navigation";
import dynamic from "next/dynamic";
const CustomModal = dynamic(() => import("@/components/common-components/CustomModal"), { ssr: false });
import PlanExpired from "@/components/common-components/plan-expired";
import { AeroDown } from "@/utlility/icons";
import Image from "next/image";
import { topHeaderLinks } from "@/utlility/Constants";

const Header = ({ initialLogo, navigationData }) => {
  const pathName = usePathname();
  const [modalShow, setModalShow] = useState(false);
  const [galleryDropdown, setGalleryDropdown] = useState(false);
  const activeMarketArea = navigationData?.market_area?.find((item) => item.is_default === true);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    setExpanded(false);
    setGalleryDropdown(false);
  }, [pathName]);
  if (navigationData?.plan_status === "expired") {
    return <PlanExpired />;
  }
  return (
    <>
      <header className="sticky-top">
        <div className="top-header d-none d-lg-block">
          <Container>
            <div className="d-flex justify-content-between align-items-center top-header-cover w-100">
              <Link href={"/"} className="logo cursor-pointer">
                {initialLogo && typeof initialLogo === 'string' && (
                  <Image
                    src={initialLogo}
                    alt="logo"
                    width={127}
                    priority
                    height={59}
                    className="rounded-pill d-block w-100"
                  />
                )}
              </Link>
              <div className="d-inline-flex align-items-center right-section">
                <ul className="list-unstyled d-flex links m-0 p-0">
                  {topHeaderLinks?.map((item, i) =>
                    item?.subLinks?.length > 0 ? (
                      <li key={i} className="position-relative gallery-dropdown">
                        <Link href={item?.href || ""} className={`link ${pathName === item?.href ? "active" : ""}`}>
                          {item?.name || ""}
                        </Link>
                        <i className="icon">
                          <AeroDown size={14} />
                        </i>
                        <ul className="list-unstyled sub-links-cover">
                          {item?.subLinks?.map((subLink, idx) => (
                            <li key={idx}>
                              <Link
                                href={`${item.href}?tab=${subLink.tab}`}
                              >
                                {subLink.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </li>
                    ) : (
                      <li key={i}>
                        <Link
                          href={item?.href || ""}
                          className={`link ${pathName === item?.href ? "active" : ""
                            }`}
                        >
                          {item?.name || ""}
                        </Link>
                      </li>
                    )
                  )}
                </ul>

                <div className="button">
                  <CustomButton
                    text="Get Appointment"
                    onClick={() => setModalShow(true)}
                  />
                </div>
              </div>
            </div>
          </Container>
        </div>

        <Navbar
          expand="lg"
          className={`custom-navbar py-lg-0 bg-white w-100`}
          collapseOnSelect
          expanded={expanded}
          onToggle={(nextExpanded) => setExpanded(nextExpanded)}
        >
          <Container>
            <Navbar.Brand as={Link} href="/" className="logo d-flex d-lg-none p-0">
              <Image
                src="/images/logos/logo.webp"
                alt="logo"
                width={127}
                priority
                height={59}
                className="rounded-pill"
              />
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="navbarScroll">
              <span className="first" />
              <span className="second" />
              <span className="third" />
            </Navbar.Toggle>

            <Navbar.Collapse id="navbarScroll" className="collaps-height">
              <Nav className="mx-auto">
                {navigationData?.categories?.map((category, index) => {
                  if (category?.sub_categories?.length === 0) {
                    return (
                      <div className="nav-item" key={index}>
                        <Link
                          href={`${category.category_slug}-in-${activeMarketArea?.slug}` || ""}
                          className={`nav-link ${pathName.includes(category.category_slug)
                            ? "active"
                            : ""
                            }`}
                        >
                          {category.category_name || ""}
                        </Link>
                      </div>
                    );
                  } else {
                    return (
                      <NavigationDropdown
                        key={index}
                        title={category.category_name}
                        href={category.category_slug}
                        content={category.sub_categories.map(
                          (subCategory) => subCategory.category_name
                        )}
                        market_area={navigationData.market_area.map(
                          (item) => item.slug
                        )}
                        default_market_area={activeMarketArea}
                        category={category}
                        className={`${pathName.includes(category.category_slug) ? "active" : ""
                          }`}
                      />
                    );
                  }
                })}

                {topHeaderLinks?.map((item, i) =>
                  item?.subLinks?.length > 0 ? (
                    <li
                      key={i}
                      className={`nav-item header-links gallery-dropdown-md ${galleryDropdown ? "show-gallery" : ""
                        }`}
                      onClick={() => setGalleryDropdown(!galleryDropdown)}
                    >
                      <Link
                        href={item?.href || ""}
                        className={`nav-link ${pathName === item?.href ? "active" : ""
                          }`}
                      >
                        {item?.name || ""}
                        <i className="icon">
                          <AeroDown />
                        </i>
                      </Link>
                      <ul className={`list-unstyled sub-links-cover p-0 m-0`}>
                        {item?.subLinks?.map((subLink, idx) => (
                          <li key={idx}>
                            <Link href={`${item.href}?tab=${subLink.tab}`}>
                              {subLink.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </li>
                  ) : (
                    <div className="nav-item header-links" key={i}>
                      <Link
                        href={item?.href || ""}
                        className={`nav-link  ${pathName === item?.href ? "active" : ""
                          }`}
                      >
                        {item?.name || ""}
                      </Link>
                    </div>
                  )
                )}

                <div className="nav-item header-links">
                  <button
                    className="nav-link border-0 w-100 bg-transparent text-start"
                    onClick={() => setModalShow(true)}
                  >
                    Get Appointment
                  </button>
                </div>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </header>
      <CustomModal show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
};

export default Header;
